import * as React from 'react';

export const RightLarge = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="-1 -1 46 22" {...props}>
    <path
      fill="currentColor"
      d="M41.131728,10.46 L32.8388348,2.16710678 L33.5459415,1.46 L43.0918831,11.0059415 L33.5459415,20.5518831 L32.8388348,19.8447763 L41.2236111,11.46 L0.5,11.46 L0.5,10.46 L41.131728,10.46 Z"
    />
  </svg>
);
